"use client";
import SheetModal from "@/components/ui/sheet-modal";
import { useEffect, useState } from "react";
import { POST_REGISTER_SESSION_NAME } from "@/@core/constants/auth";
import dynamic from "next/dynamic";

const SignUpSelectInterest = dynamic(
  () => import("@/components/views/modals/sign-up/steps/SelectInterest"),
  { ssr: false },
);
const SignUpGenderScreen = dynamic(
  () => import("@/components/views/modals/sign-up/steps/GenderStep"),
  { ssr: false },
);
const SignUpUploadAvatar = dynamic(
  () => import("@/components/views/modals/sign-up/steps/UploadAvatar"),
  { ssr: false },
);

export default function PostSignUpModal() {
  const [show, setShow] = useState(false);
  const [registerStep, setRegisterStep] = useState<
    "select_interest" | "select_gender" | "upload_avatar"
  >("select_interest");

  useEffect(() => {
    const hasSeenPostRegistrationDrawer = sessionStorage.getItem(
      POST_REGISTER_SESSION_NAME,
    );
    if (hasSeenPostRegistrationDrawer == "1") {
      setShow(true);
      sessionStorage.removeItem(POST_REGISTER_SESSION_NAME);
    }
  }, []);

  if (!show) return null;

  return (
    <SheetModal
      className="max-h-[90%]"
      isOpen={show}
      onClose={() => setShow(false)}
    >
      {registerStep === "select_interest" && (
        <SignUpSelectInterest
          nextPage={() => setRegisterStep("select_gender")}
        />
      )}

      {registerStep === "select_gender" && (
        <SignUpGenderScreen nextPage={() => setRegisterStep("upload_avatar")} />
      )}

      {registerStep === "upload_avatar" && (
        <SignUpUploadAvatar closeModal={() => setShow(false)} />
      )}
    </SheetModal>
  );
}
